import { createSlice } from '@reduxjs/toolkit';

import {
  cleanEvents,
  createRanges,
} from 'organisms/DrawerContent/Availability/util';

const inventory = createSlice({
  name: 'inventory',
  initialState: {
    isLoadingInventory: false,
    isLoadingAppointments: false,
    unavailable: [],
    recurring: [],
    single: [],
    availabilityCombined: [], // single + recurring (sorted, without dupes)
    availabilityMerged: [], // single + recurring (sorted, without dupes), merged as big ranges
    recurringDOW: [],
    allGroomers: [],
    groomerUuid: null,
    appointments: [],
  },
  reducers: {
    inventoryRequest(state) {
      state.isLoadingInventory = true;
    },

    inventorySuccess(state, { payload }) {
      const recurringEvents = [];
      const singleEvents = [];
      const unavailableEvents = [];

      payload.calendar?.forEach(
        ({ date: eventDate, recurring, single, unavailable }) => {
          recurring.forEach(({ date, uuid }) => {
            recurringEvents.push({
              eventDate,
              display: 'background',
              start: date.start,
              end: date.end,
              title: `Available`,
              textColor: 'black',
              isAvailability: true,
              uuid,
            });
          });

          single.forEach(({ date, uuid }) => {
            singleEvents.push({
              eventDate,
              display: 'background',
              start: date.start,
              end: date.end,
              title: `Available`,
              textColor: 'black',
              isAvailability: true,
              uuid,
            });
          });

          if (unavailable.length > 0) {
            unavailable.forEach(({ date, uuid, location }) => {
              const groomer = state.allGroomers.find(
                (g) => g.user.uuid === location.user.uuid
              );

              unavailableEvents.push({
                date: eventDate,
                start: date.start,
                end: date.end,
                title: `Unavailable`,
                textColor: 'white',
                backgroundColor: '#9191A8',
                borderColor: '#9191A8',
                isUnavailable: true,
                uuid,
                groomer: {
                  uuid: groomer.user.uuid,
                  firstName: groomer.user.firstName,
                  links: groomer.user.links,
                },
              });
            });
          }
        }
      );

      // We're going to merge events, sort them, and remove dupes
      const cleanAvailableEvents = cleanEvents([
        ...recurringEvents,
        ...singleEvents,
      ]);

      const mergedAvailableEvents = createRanges(cleanAvailableEvents);

      return {
        ...state,
        isLoadingInventory: false,
        unavailable: unavailableEvents,
        recurring: recurringEvents,
        single: singleEvents,
        availabilityCombined: cleanAvailableEvents,
        availabilityMerged: mergedAvailableEvents,
        recurringDOW: payload.recurring,
      };
    },
    inventoryFailure(state) {
      state.isLoadingInventory = false;
    },
    appointmentsRequest(state) {
      state.isLoadingAppointments = true;
    },
    appointmentsSuccess(state, { payload }) {
      const appointmentsEvents = [];

      payload.data.calendar?.forEach(({ date, appointments }) => {
        const today = new Date();
        const eventDate = new Date(date);

        appointments.forEach((appt) => {
          appointmentsEvents.push({
            title: appt.service.name,
            start: appt.dateStart,
            end: appt.dateEnd,
            description: {
              serviceDuration: appt.service.durationMinutes,
              animal: appt.animal,
              groomer: appt.locationUser.firstName,
            },
            isPastAppointment: today > eventDate,
            extendedProps: {
              uuid: appt.uuid,
            },
          });
        });
      });

      return {
        ...state,
        isLoadingAppointments: false,
        appointments: appointmentsEvents,
      };
    },
    appointmentsFailure(state) {
      state.isLoadingAppointments = false;
    },
    setGroomerUuid(state, { payload }) {
      state.groomerUuid = payload;
    },
    setAllGroomers(state, { payload }) {
      state.allGroomers = payload;
    },
  },
});

const { actions, reducer } = inventory;

export const {
  inventoryRequest,
  inventorySuccess,
  inventoryFailure,
  appointmentsRequest,
  appointmentsSuccess,
  appointmentsFailure,
  setGroomerUuid,
  setAllGroomers,
} = actions;

export default reducer;
